import type { ReactNode } from 'react'

import { pesos } from '@/shared/utilidades/formato'

import type { GrupoDeCartera } from './agrupar'
import { EDADES } from './edades'
import estilos from './PaginaCartera.module.css'

/**
 * Una sección de tarjetas: su nombre, cuántas cuentas, lo que debe y cómo se
 * reparte por edad. Agrupada por edad, la cabecera lleva el color de su edad
 * (el mismo de la barra de arriba); agrupada por otra cosa, una barrita dice
 * qué tan vieja es la plata de ese grupo.
 */
export function GrupoDeCuentas({ grupo: g, children }: { grupo: GrupoDeCartera; children: ReactNode }) {
  const conDeuda = EDADES.filter((e) => g.porEdad[e.clave] > 0)

  return (
    <section className={`${estilos.grupo} ${g.edad ? estilos[g.edad] : ''}`}>
      <header className={`${estilos.grupoTope} ${g.edad ? estilos.grupoTopeEdad : ''}`}>
        <h3>
          {g.edad && <i className={estilos.grupoPunto} aria-hidden="true" />}
          {g.titulo}
        </h3>
        <span>
          {g.filas.length} {g.filas.length === 1 ? 'cuenta' : 'cuentas'}
          {g.saldo > 0 && (
            <>
              {' '}
              · debe <b>{pesos(g.saldo)}</b>
            </>
          )}
        </span>

        {!g.edad && conDeuda.length > 0 && (
          <div className={estilos.grupoEdades}>
            <div className={estilos.grupoBarra} aria-hidden="true">
              {conDeuda.map((e) => (
                <span key={e.clave} className={estilos[e.clave]} style={{ flexGrow: g.porEdad[e.clave] }} />
              ))}
            </div>
            <ul>
              {conDeuda.map((e) => (
                <li key={e.clave} className={estilos[e.clave]}>
                  <i aria-hidden="true" />
                  {e.rotulo} <b>{pesos(g.porEdad[e.clave])}</b>
                </li>
              ))}
            </ul>
          </div>
        )}
      </header>
      <div className={estilos.cuentas}>{children}</div>
    </section>
  )
}
